module.exports = __webpack_public_path__ + "img/image6.0f54f151.png";